import { render } from "./Sv007.vue?vue&type=template&id=665797cb&scoped=true"
import script from "./Sv007.vue?vue&type=script&lang=js"
export * from "./Sv007.vue?vue&type=script&lang=js"

import "./Sv007.vue?vue&type=style&index=0&id=665797cb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665797cb"]])

export default __exports__